import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import S from './Button.styles';
import IconPerson from '@img/icons/person.svg';
import IconChevronRight from '@img/icons/chevron-right.svg';
import IconThickChevronRight from '@img/icons/thick-chevron.svg';
import IconChevronDown from '@img/icons/chevron-down.svg';
const getIcon = (icon) => {
    if (!icon) {
        return React.createElement(React.Fragment, null);
    }
    switch (icon) {
        case 'person':
            return React.createElement(IconPerson, null);
        case 'chevron-right':
            return React.createElement(IconChevronRight, null);
        case 'thick-chevron-right':
            return React.createElement(IconThickChevronRight, null);
        case 'chevron-down':
            return React.createElement(IconChevronDown, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
const Button = ({ variant = 'button', children, theme = 'light-blue', themeHover = undefined, size = 'medium', icon, iconPosition = 'left', inverted, ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: "button", "data-size": size, "data-inverted": inverted, "data-theme": theme, "data-theme-hover": themeHover, "data-variant": variant, "data-icon": icon, ...otherProps },
            icon && iconPosition === 'left' && React.createElement(S.IconWrapper, null, getIcon(icon)),
            React.createElement(S.Text, null, children),
            icon && iconPosition === 'right' && React.createElement(S.IconWrapper, null, getIcon(icon)))));
};
const LinkButton = ({ variant = 'button', children, theme = 'light-blue', themeHover = undefined, size = 'medium', icon, iconPosition = 'left', inverted, ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: "a", "data-size": size, "data-inverted": inverted, "data-theme": theme, "data-theme-hover": themeHover, "data-variant": variant, "data-icon": icon, ...otherProps },
            icon && iconPosition === 'left' && React.createElement(S.IconWrapper, null, getIcon(icon)),
            React.createElement(S.Text, null, children),
            icon && iconPosition === 'right' && React.createElement(S.IconWrapper, null, getIcon(icon)))));
};
export { Button as default, LinkButton };
